import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Header } from "../../../components/header";
import { SendIcon } from "../../../components/icons";
import { parseSearchParams } from "../../../helpers/clean-object";

import { ScanForm } from "../components";
import { useCreateScan } from "../hooks";

export const CreateScan: React.FC = () => {
  const [params] = useSearchParams();

  const { form, submit, loading } = useCreateScan({
    defaultValues: {
      ...parseSearchParams(params),
    },
    onCompleted: () => toast.success("Le demande a été créé avec succès"),
    onError: (msg) => toast.error(msg),
  });

  return (
    <>
      <Header
        title="Scan"
        subtitle="Ajouter une information"
        buttons={[
          {
            actionText: "Annuler",
            bgColor: "indigo",
            textColor: "white",
            link: "/scans",
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <ScanForm loading={loading} submit={submit} form={form} />
      </div>
    </>
  );
};
